<div class="carrier-view-header">
  <div class="carrier-view-header__left">
    @if (showGoBack()) {
      <button class="dialog__goBack" (click)="goBack.emit()">
        <fr8bot-ui-icon name="arrow-left-16" [size]="16" />
      </button>
    }

    <div class="carrier-view-header__left-icon">
      <ng-content select="[icon]"></ng-content>
    </div>

    <div class="carrier-view-header__left-info">
      <div class="carrier-view-header__left-info-container">
        <span class="carrier-view-header__left-info-name">
          <ng-content select="[name]"></ng-content>
        </span>
      </div>

      <div class="carrier-view-header__left-info-bottom">
        <ng-content select="[bottom]"></ng-content>
      </div>
    </div>
  </div>

  <div class="carrier-view-header__right df gap20 ai-c">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
